import { Heading, HelpText, TextLink } from '@mm/components';
import React from 'react';
import { campaignTypeByKind, UIFilterCampaignKindType } from '../types';
import './SharedCells.pcss';

export const CampaignBaseInfo = ({
  headingText,
  subHeadingText,
  bottomText,
}: {
  headingText: string;
  subHeadingText?: string;
  bottomText?: string;
}) => {
  return (
    <div className="campaigns-base-cell">
      <Heading
        className="campaigns-base-cell__heading h-overflow-text"
        size={5}
        text={headingText}
      />
      {subHeadingText && (
        <div className="campaigns-base-cell__sub-heading h-overflow-text">
          <HelpText text={subHeadingText} />
        </div>
      )}
      {bottomText && (
        <div className="campaigns-base-cell__bottom-text h-overflow-text">
          <HelpText text={bottomText} />
        </div>
      )}
    </div>
  );
};

export const Kind = ({ kind }: { kind: UIFilterCampaignKindType }) => {
  const { name, icon: Icon } = campaignTypeByKind[kind];
  return (
    <TextLink className="starters-table__starter-kind" icon={<Icon />}>
      {name}
    </TextLink>
  );
};
